
import { useState } from 'react';
import React from 'react';
import { useMobileNavStyles } from '../styles/muiStyles';

import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import MessageIcon from '@material-ui/icons/Message';
import VideoCallIcon from '@material-ui/icons/VideoCall';
import PersonIcon from '@material-ui/icons/Person';
import MobileDialogBox from './MobileDialogbox';
import Profile from '../pages/Profile/Profile';
import { Link } from 'react-router-dom';
import { useStateContext } from '../context/state';

const BottomNav = () => {
  const classes = useMobileNavStyles();
  const [profileModal, setProfileModal] = useState(false);
  const [value, setValue] = React.useState(0);

  const { selectedChat } = useStateContext();

  return (
   <div  className={!selectedChat ? "" : classes.display}>
        <BottomNavigation 
            value={value}
            onChange={(event, newValue) => {
            setValue(newValue);
            }}
            showLabels
            className={classes.stickToBottom} >
            
            <BottomNavigationAction 
                label="Messages" 
                icon={<MessageIcon />}
                component={Link}
                to='/messages' 
                />
            <BottomNavigationAction
                label="Virtual Room" 
                icon={<VideoCallIcon />}
                component={Link}
                to="/virtualroom"
                />
            <BottomNavigationAction 
                label="Profile"
                onClick={() => setProfileModal(true)}
                icon={<PersonIcon />} 

        />
        
        </BottomNavigation>
        <MobileDialogBox
            title="Profile"
            modalOpen={profileModal}
            setModalOpen={setProfileModal}
            children={
            <Profile closeModal={() => setProfileModal(false)} />
        }
        />
    </div>
    );
};

export default BottomNav;
